const getAudience = (list, key) => list.map(entry => ({ [key]: entry.id }))

const getPrimaryAudience = ({
  target,
  newsCountries,
  newsRepresentatives,
  newsStores,
}) => {
  switch (target) {
    case 'countries':
      return getAudience(newsCountries, 'country')
    case 'representatives':
      return getAudience(newsRepresentatives, 'representative')
    case 'stores':
      return getAudience(newsStores, 'store')
    default:
      return [{ everyone: 'everyone' }]
  }
}

const getSecondaryAudience = ({ roleTarget, newsRoles }) =>
  roleTarget === 'specific-roles'
    ? newsRoles.map(role => ({ role: role.id }))
    : []

export const createNewsRequest = ({
  id,
  message,
  targetData,
  time,
  tags,
  published,
}) => {
  const newsRequest = {
    body: message.text,
    excludedAudiences: [],
    header: message.title,
    languageCode: 'SE',
    primaryAudiences: getPrimaryAudience(targetData),
    publicationStart: time.startDate,
    secondaryAudiences: getSecondaryAudience(targetData),
    tags,
    visible: published,
  }

  // Add or update?
  if (id) {
    newsRequest.id = id
  }

  if (!time.untilFurtherNotice) {
    newsRequest.publicationEnd = time.endDate
  }
  return JSON.stringify(newsRequest)
}
